import { clientEnvSchema, formatEnvErrors } from "@purlink/shared/env";

const result = clientEnvSchema.safeParse(import.meta.env);
if (!result.success) {
  throw new Error(`Invalid client environment:\n${formatEnvErrors(result.error)}`);
}

export const env = result.data;
